// styles
import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    color,
    data,
    fmtYearAbbrev,
    fmtYearFull,
    fmtMonth,
    height,
    initialWidth,
    initialHeight,
    margins,
    path,
    width,
    x,
    xAxis,
    y,
    yAxis,
    recessionData,
    calloutValue,
    calloutLabel,
  } = props;

  function replaceCharacter(val) {
    return val.replace(/_/g, ' ');
  }

  // const xTicks = isMobile ? 5 : 10;
  const yTicks = isMobile ? 7 : 7;

  // const ticksMobi = ['1/1/1930', '1/1/1940', '1/1/1950', '1/1/1960', '1/1/1970', '1/1/1980', '1/1/1990', '1/1/2000', '1/1/2010', '1/1/2020'];
  const ticksMobi = [
    '1/1/2011',
    '1/1/2013',
    '1/1/2015',
    '1/1/2017',
    '1/1/2019',
    '1/1/2021',
  ];

  const dates = {
    January: 'Jan.',
    // February: 'Feb.',
    // March: 'March',
    // April: 'April',
    // May: 'May',
    // June: 'June',
    // July: 'July',
    // August: 'Aug.',
    // September: 'Sept.',
    // October: 'Oct.',
    // November: 'Nov.',
    December: 'Dec.',
  };
  //
  const xGrid = xAxis(x)
    .tickValues(ticksMobi.map(d => new Date(d)))
    .tickFormat(d => (isMobile
      ? `\u2019${fmtYearAbbrev(d)}`
      : fmtYearFull(d)));

  // legend
  container
    .insert('ul', ':first-child')
    .attr('class', 'key')
    .selectAll('li')
    .data(data)
    .enter()
    .append('li')
    .attr('class', 'key-item')
    .html(
      d => `<span class='key-block' style='background-color:${color(
        d.id,
      )};'></span> ${replaceCharacter(d.id)} (JOLTS)`,
    );

  // svg
  const svg = container
    .append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg
    .append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  // x axis
  g.append('g')
    .attr('class', 'grid x')
    .attr('transform', `translate(${[0, height]})`)
    .call(xGrid);

  // y axis
  const yGrid = g
    .append('g')
    .attr('class', 'grid y')
    .call(
      yAxis(y)
        .ticks(yTicks)
        .tickFormat(d => `${d / 1000}M`),
    );

  // yGrid.select('text').style('display', 'none'); // hide first tick's text
  yGrid.selectAll('line').attr('x2', width);

  // recessions
  const recessions = g.append('g').attr('class', 'recessions');

  recessions
    .selectAll('.recession')
    .data(recessionData)
    .enter()
    .append('rect')
    .attr('class', 'recession')
    .attr('transform', d => `translate(${[x(d.start), 0]})`)
    .attr('width', d => x(d.end) - x(d.start))
    .attr('height', height)
    .style('fill', 'grey')
    .style('fill-opacity', 0.0);
  // .style('fill-opacity', 0.09);

  recessions
    .append('text')
    .attr('class', 'label-recession')
    .attr('transform', `translate(${[x(new Date('2/1/2020')) + 5, 15]})`)
    .attr('text-anchor', 'start');
  // .text('Recession');

  // lines
  const lines = g
    .append('g')
    .attr('class', 'lines')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', d => `line line-${d.id}`);

  lines
    .append('path')
    .attr('stroke', d => color(d.id))
    .attr('d', d => path(d.values));


  // last data point
  const lastDataValue = data[0].values[data[0].values.length - 1].value;


  // circle on jobs line
  lines
    .append('circle')
    .attr('cx', x(x.domain()[1]))
    .attr('cy', y(lastDataValue))
    .attr('r', 3)
    .attr('stroke', 'none')
    .attr('fill', '#444');

  // connect
  lines
    .append('line')
    .attr('x1', x(x.domain()[1]))
    .attr('y1', y(lastDataValue))
    .attr('x2', x(x.domain()[1]))
    .attr('y2', y(lastDataValue) - 10)
    .attr('stroke-width', 1)
    .attr('stroke', 'black');

  // labels
  const label = lines.append('g').attr('class', 'data-label');
  /*
  label
  .append('text')
    .attr('transform', (d) => {
      // console.log(d);
      const d0 = d.values.filter((obj) => {
        if (obj.date.getTime() == x.domain()[1].getTime()) {
          return obj;
        }
      });
      // const d0 = (d.id === 'Projection') ? d.values.find((val, index, arr) => index === arr.length - 1) : null;
      const x0 = x(d0[0].date) - 5;
      const y0 = (y(lastDataValue) + y(d0[0].value)) / 2 + 3;
      return `translate(${[x0, y0]})`;
    })
    .style('text-anchor', 'end')
    .text((d) => {
      const d0 = d.values.filter((obj) => {
        if (obj.date.getTime() == x.domain()[1].getTime()) {
          return obj;
        }
      });
      const { value } = d0[0];
      // console.log(value, data);
      // return isMobile
      //  ? `-${((152523 - value) / 1000).toFixed(1)}M`
      //  : `-${((152523 - value) / 1000).toFixed(1)}M`;
      return `${((lastDataValue - value) / 1000).toFixed(
        1,
      )}M fewer jobs since Feb. '20`;
    }); */

  label
    .append('text')
    .attr('transform', (d) => {
      // console.log(d);
      const d0 = d.values.filter((obj) => {
        if (obj.date.getTime() == x.domain()[1].getTime()) {
          return obj;
        }
      });
      // const d0 = (d.id === 'Projection') ? d.values.find((val, index, arr) => index === arr.length - 1) : null;
      const x0 = x(d0[0].date) + 5;
      const y0 = (y(lastDataValue) + y(d0[0].value)) / 2 + (isMobile ? 18 : 20);
      return `translate(${[x0, y0]})`;
    })
    .style('text-anchor', 'start')
    .text((d) => {
      const d0 = d.values.filter((obj) => {
        if (obj.date.getTime() == x.domain()[1].getTime()) {
          return obj;
        }
      });
      const { value } = d0[0];
      // console.log(value, data);
      // return isMobile ? 'since Feb. \u201920' : 'since Feb. \u201920';
    });

  label
    .append('text')
    .attr('x', x(new Date('12/1/2021')))
    .attr('y', y(lastDataValue) - 15)
    .style('font-size', '14px')
    .style('text-anchor', 'end')
    .text('Dec. \u201921');

  label
    .append('text')
    .attr('x', x(new Date('12/1/2021')))
    .attr('y', y(lastDataValue) - 30)
    .style('font-size', '16px')
    .style('text-anchor', 'end')
    .text('10.9 million');
}
